require([],
    function() {
        let isInactiveCommunity = document.querySelector("[data-is-inactive-community]");
        let module = "";
        if (isInactiveCommunity) {
          module = "showInactiveCommunity";
        } else {
          module = "showActiveCommunity";
        }
        require([module]);
    });

define("pwa/pages/CommunityDetail/show", function(){});

